import { useInterpret, useSelector } from "@xstate/react";
import { useEffect } from "react";
import { createReactContextHelpers } from "xstate-helpers/react";

import { Availability, BookingQuestion, useCacheAvailability } from "../../apiHooks";
import { availabilityFormMachine } from "./availabilityForm.machine";

export const {
    Provider: AvailabilityFormProvider,
    useSelector: useAvailabilityFormSelector,
    useSend: useAvailabilityFormSend,
} = createReactContextHelpers(
    "AvailabilityForm",
    (props: { availabilityId: string; saleCurrency?: string; initialAvailability?: Availability | null }) => {
        const service = useInterpret(availabilityFormMachine, {
            devTools: true,
            context: {
                availabilityId: props.availabilityId,
                saleCurrency: props.saleCurrency,
                initialAvailability: props.initialAvailability,
            },
        });
        useEffect(() => {
            service.send({ type: "AVAILABILITY_ID_UPDATE", availabilityId: props.availabilityId });
        }, [service, props.availabilityId]);

        const availabilityId = useSelector(service, (state) => state.context.availabilityId);
        const saleCurrency = useSelector(service, (state) => state.context.saleCurrency);
        const availabilityInput = useSelector(service, (state) => state.context.availabilityInput);
        const isDebouncing = useSelector(service, (state) => state.hasTag("debouncing"));

        const availabilityQuery = useCacheAvailability({
            variables: { id: availabilityId, saleCurrency, input: availabilityInput },
            skip: isDebouncing,
        });
        const data = availabilityQuery.data;

        useEffect(() => {
            if (data?.availability) {
                service.send({ type: "AVAILABILITY_UPDATE", availability: data.availability });
            }
        }, [service, data?.availability]);
        useEffect(() => {
            if (availabilityQuery.error) {
                service.send({ type: "AVAILABILITY_ERROR", error: availabilityQuery.error });
            }
        }, [service, availabilityQuery.error]);

        return service;
    }
);
export const useAvailabilityFormInputOption = (option: BookingQuestion) => {
    return useAvailabilityFormSelector((state) =>
        state.context.availabilityInput.optionList.find((o) => o.id === option.id)
    );
};
